<script context="module">
  import { FIT_TYPES, PROPORTIONS } from '../utils'

  export { FIT_TYPES, PROPORTIONS }
</script>

<script>
  import { getClass, getImageClass, getSrc } from '../utils'
  import { mediaBreakPoints } from '../../../constants'

  export let type
  export let alt = ''
  export let src
  export let srcMiddle = undefined
  export let srcWide = undefined
  export let webpSrc = undefined
  export let webpSrcMiddle = undefined
  export let webpSrcWide = undefined
  export let fitType = FIT_TYPES.CONTAIN

  $: className = getClass({ type, className: $$props.class || '' })
  $: imageClassName = getImageClass({ fitType })
</script>

<div {...$$restProps} class={className}>
  <picture class={imageClassName}>
    {#if webpSrcWide !== undefined}
      <source
        media={`(min-width: ${mediaBreakPoints.wide}px)`}
        srcset={getSrc(webpSrcWide)}
        type="image/webp" />
    {/if}
    {#if srcWide !== undefined}
      <source media={`(min-width: ${mediaBreakPoints.wide}px)`} srcset={getSrc(srcWide)} />
    {/if}

    {#if webpSrcMiddle !== undefined}
      <source
        media={`(min-width: ${mediaBreakPoints.middle}px)`}
        srcset={getSrc(webpSrcMiddle)}
        type="image/webp" />
    {/if}
    {#if srcMiddle !== undefined}
      <source media={`(min-width: ${mediaBreakPoints.middle}px)`} srcset={getSrc(srcMiddle)} />
    {/if}

    {#if webpSrc !== undefined}
      <source srcset={getSrc(webpSrc)} type="image/webp" />
    {/if}
    <img {alt} src={src[0]} srcSet={getSrc(src, 1)} class={imageClassName} />
  </picture>
</div>
